import { forwardRef as t } from "react";
import { Flex as o } from "theme-ui";
import { jsx as n } from "theme-ui/jsx-runtime";
const m = t((e, r) => /* @__PURE__ */ n(o, {
  ...e,
  ref: r,
  sx: {
    alignItems: "center",
    justifyContent: "center",
    ...e.sx
  }
}));
m.displayName = "CenteredBox";
export {
  m as CenteredBox
};
